const points = document.querySelectorAll('.strengs_point_item');
const imgBox = document.querySelector('.strength_main_img_box');
const imgList = document.querySelector('.strength_main_img_box ul');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {

      const index = parseInt(entry.target.dataset.index, 10) - 1;

      imgBox.setAttribute('data-active-index', index + 1);

      imgList.style.transform = `translateX(-${index * 100}%)`;
    }
  });
}, {
  threshold: 0.5
});

points.forEach(point => observer.observe(point));